/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import Axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import {
  TableBody,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

// Utils
import {
  getTaskCompletionStatus,
  getSorting,
  stableSort,
  getLocalTimeString,
  isQuestOver
} from '../../../../../utils/functions';

// Styles
import '../QuestPaymentsTableNew.scss';

// 表头样式
const TableHeaderCell = withStyles(theme => ({
  head: {
    color: '#9b9b9b',
    fontWeight: '400',
    letterSpacing: '1.2px',
    fontSize: '14px',
  },
}))(TableCell);

// 状态颜色
const getStatusColor = status => {
  switch (status) {
    case 'In Progress': return '#ffffff';
    case 'Already Paid': return '#4caf50';
    case 'To be paid': return '#2196f3';
    default: return '#ffffff';
  }
};

class QuestPaymentsTableSecond extends React.Component {
  state = {
    orderBy: 'dateAccepted',
    order: 'asc',
    isSettling: false,
    settleMsg: '',
    settleDialogOpen: false,
    settleDialogType: 'success', // 'success' | 'error'
  };

  handleRequestSort = (event, property) => {
    const { order, orderBy } = this.state;
    this.setState({
      order: orderBy === property && order === 'desc' ? 'asc' : 'desc',
      orderBy: property,
    });
  };

  handleTestAutoSettle = async () => {
    const { quest, auth } = this.props;
    if (!quest?.id || !auth?.token) {
      this.setState({
        settleMsg: '缺少任务ID或token',
        settleDialogOpen: true,
        settleDialogType: 'error',
      });
      return;
    }
    this.setState({ isSettling: true, settleMsg: '' });
    try {
      const config = { headers: { Authorization: `JWT ${auth.token}` } };
      const body = { questId: quest.id };
      const res = await Axios.post('/api/v1/admin/test-secondary-auto-checkout', body, config);
      if (res.data && res.data.code === 'QUEST_MANUAL_SETTLEMENT_COMPLETED') {
        this.setState({
          settleMsg: '自动结算成功！',
          settleDialogOpen: true,
          settleDialogType: 'success',
        });
      } else {
        this.setState({
          settleMsg: res.data?.message || '自动结算返回未知结果',
          settleDialogOpen: true,
          settleDialogType: 'error',
        });
      }
    } catch (err) {
      this.setState({
        settleMsg: err.response?.data?.message || err.message || '请求失败',
        settleDialogOpen: true,
        settleDialogType: 'error',
      });
    } finally {
      this.setState({ isSettling: false });
    }
  };

  handleCloseSettleDialog = () => {
    this.setState({ settleDialogOpen: false });
  };

  getTableHeaders = () => [
    { id: 'username', label: 'Noiz' },
    { id: 'youtubeName', label: 'Youtube' },
    { id: 'splitAmount', label: 'Tier Amount' },
    { id: 'leaderboardAmount', label: 'Rank Amount' },
    { id: 'totalAmount', label: 'Total Amount' },
    { id: 'completionStatus', label: 'Status' },
    { id: 'paymentTime', label: 'Payment Time' },
  ];

  // 展平用户数据
  flattenUser = (user, quest) => {
    console.log("user",user)
    const total = (user.splitAmount || 0) + (user.leaderboardAmount || 0);
    const status = getTaskCompletionStatus(quest).statusString;
    const paymentTime = user.paymentDateTime
      ? getLocalTimeString(user.paymentDateTime)
      : (quest.expectedPayoutDate ? getLocalTimeString(quest.expectedPayoutDate) : '-');
    return {
      ...user,
      username: user.user?.username || '-',
      youtubeName: user.user?.connectedAccounts?.youtube?.username || '-',
      splitAmount: user.splitAmount || 0,
      leaderboardAmount: user.leaderboardAmount || 0,
      totalAmount: total,
      completionStatus: status,
      paymentTime,
    };
  };

  getUserRows = users => {
    const { quest } = this.props;
    const { order, orderBy } = this.state;
    const flattened = users.map(u => this.flattenUser(u, quest));
    const sorted = stableSort(flattened, getSorting(order, orderBy));
    return sorted.map((user, idx) => (
      <TableRow hover tabIndex={-1} key={user.id || idx}>
        <TableCell align="center">{user.username}</TableCell>
        <TableCell align="center">{user.youtubeName}</TableCell>
        <TableCell align="center">${user.splitAmount.toFixed(2)}</TableCell>
        <TableCell align="center">${user.leaderboardAmount.toFixed(2)}</TableCell>
        <TableCell align="center">${user.totalAmount.toFixed(2)}</TableCell>
        <TableCell align="center">
          <span style={{ color: getStatusColor(user.completionStatus) }}>
            {user.completionStatus}
          </span>
        </TableCell>
        <TableCell align="center">{user.paymentTime}</TableCell>
      </TableRow>
    ));
  };

  render() {
    let { quest, userQuests = [] } = this.props;
    const { order, orderBy, settleMsg, settleDialogOpen, settleDialogType } = this.state;
    const headers = this.getTableHeaders();
    console.log("quest",quest)
    // 新增：任务未结束时不显示数据
    // if (quest.status !== 'completed') {
    //   userQuests = []
    // }
    if(!isQuestOver(quest)){
      userQuests = []
    }

    return (
      <section className="ToggleTable">
        <div style={{ padding: '10px 30px 0 30px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className="Global__subTabs" style={{ padding: '30px 30px 10px 30px' }}>
            <button className="platform-twitch-btn active" data-platform="twitch">
              <svg className="platform-twitch-btn-icon" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
              Youtube
            </button>
          </div>
          {/* <button
            className="platform-twitch-btn active"
            data-platform="twitch"
            style={{ marginLeft: "auto" }}
            onClick={this.handleTestAutoSettle}
            disabled={isSettling}
          >
            {isSettling ? '结算中...' : '测试自动结算'}
          </button> */}
        </div>
        {/* 弹框显示结算结果 */}
        <Dialog open={settleDialogOpen} onClose={this.handleCloseSettleDialog}>
          <DialogTitle>{settleDialogType === 'success' ? '操作成功' : '操作失败'}</DialogTitle>
          <DialogContent>
            <span style={{ color: settleDialogType === 'success' ? '#43a047' : '#e53935' }}>{settleMsg}</span>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseSettleDialog} color="primary">确定</Button>
          </DialogActions>
        </Dialog>
        {userQuests.length ? (
          <Table>
            <TableHead>
              <TableRow>
                {headers.map(headCell => (
                  <TableHeaderCell
                    key={headCell.id}
                    align="center"
                    sortDirection={orderBy === headCell.id ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={e => this.handleRequestSort(e, headCell.id)}
                      IconComponent={ArrowDropDownIcon}
                      style={{ marginLeft: '30px' }}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  </TableHeaderCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.getUserRows(userQuests)}
            </TableBody>
          </Table>
        ) : (
          <div className="NoQuestTiered">No data yet.</div>
        )}
      </section>
    );
  }
}

export default QuestPaymentsTableSecond;